(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // Tabs
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var buttons = root.querySelectorAll('[role="tab"]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          var selected = b === btn;
          b.setAttribute('aria-selected', selected);
          document.getElementById(b.getAttribute('aria-controls')).hidden = !selected;
        });
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(parseInt(input.min || 0, 10), v + parseInt(b.dataset.step, 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant select -> price + hidden id
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var price = document.querySelector('[data-product-price]');
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      var btns = form.querySelectorAll('[type="submit"]');
      btns.forEach(function (b) { b.disabled = opt.dataset.available !== 'true'; });
    });
  });

  // Animated counters
  function animateCount(el) {
    var target = parseFloat(el.dataset.count);
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var start = null;
    var duration = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(target * eased).toLocaleString('en-US') + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        if (e.target.dataset.count) animateCount(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal, [data-count]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
